import { type LucideIcon } from 'lucide-react';
import { cn } from 'lib/utils';
export type IconMessageProps = {
    icon: LucideIcon;
    title: string;
    subtitle?: string;
    buttons?: React.ReactNode[];
    titleClassName?: string;
    subtitleClassName?: string;
};

export const IconMessage = ({
    icon: Icon,
    title,
    subtitle,
    buttons,
    titleClassName,
    subtitleClassName,
}: IconMessageProps) => {
    return (
        <div className="flex flex-col items-center justify-center">
            <div className="mb-4 rounded-md bg-primary/10 p-2">
                <Icon className="h-6 w-6 text-primary" />
            </div>
            <h3
                className={cn(
                    'text-md font-semibold text-foreground',
                    titleClassName,
                )}
            >
                {title}
            </h3>
            {subtitle && (
                <p
                    className={cn(
                        'text-center text-sm text-muted-foreground',
                        subtitleClassName,
                    )}
                >
                    {subtitle}
                </p>
            )}
            {buttons && <div className="mt-4 flex gap-2">{buttons}</div>}
        </div>
    );
};
